<template>
  <div class="reserve">
    <div class="reserve-title">风格测试设置</div>
    <div class="com-content" v-if="styleTestData.loadingPage.loadingBackImg">
      <div class="title-box">
        <span>加载页面</span>
        <span class="edit-color" @click="editLoading">编辑</span>
      </div>
      <div class="box">
        <span>背景图</span>
        <div class="img">
          <img class="img" 
            :src="styleTestData.loadingPage.loadingBackImg" 
            alt="" 
            @click="imagePreview(styleTestData.loadingPage.loadingBackImg)" />
        </div>
      </div>
      <div class="box">
        <span>加载文案</span>
        <div class="text">{{styleTestData.loadingPage.loadingText}}</div>
      </div>
    </div>
    <div class="btn-box" v-else @click="addLoading">添加加载页</div>
    <div class="com-content" v-if="styleTestData.homePage.homeBackImg">
      <div class="title-box">
        <span>首页</span>
        <span  class="edit-color" @click="editHomePage">编辑</span>
      </div>
      <div class="home-box">
        <div class="item-box">
          <div class="img">
            <img 
              class="img" 
              :src="styleTestData.homePage.homeBackImg" 
              alt="" 
              @click="imagePreview(styleTestData.homePage.homeBackImg)" 
            /> 
          </div>
          <span>背景图</span>
        </div>
         <div class="item-box">
          <div class="img">
            <img 
              class="img" 
              :src="styleTestData.homePage.homeTitleImg" 
              alt="" 
              @click="imagePreview(styleTestData.homePage.homeTitleImg)" 
            />
          </div>
          <span>标题</span>
        </div>
        <div class="item-box">
          <div class="img">
            <img 
              class="img" 
              :src="styleTestData.homePage.homeVisionImg" 
              alt="" 
              @click="imagePreview(styleTestData.homePage.homeVisionImg)" 
            />
          </div>
          <span>主视图</span>
        </div>
      </div>
    </div>
    <div class="btn-box" v-else @click="addHome">添加首页</div>
    <div class="com-content" v-if="styleTestData.dialoguePage.dialogueBackImg">
      <div class="title-box">
        <span>对话页</span>
        <span class="edit-color" @click="editDialogue">编辑</span>
      </div>
      <div class="home-box">
        <div class="item-box">
          <div class="img">
            <img 
              class="img" 
              :src="styleTestData.dialoguePage.dialogueBackImg" 
              alt="" 
              @click="imagePreview(styleTestData.dialoguePage.dialogueBackImg)" 
            />
          </div>
          <span>过渡页背景</span>
        </div>
         <div class="item-box">
          <div class="img">
            <img 
              class="img" 
              :src="styleTestData.dialoguePage.dialogueAImg" 
              alt="" 
              @click="imagePreview(styleTestData.dialoguePage.dialogueAImg)" 
            />
          </div>
          <span>过渡页对话A</span>
        </div>
        <div class="item-box">
          <div class="img">
            <img 
              class="img" 
              :src="styleTestData.dialoguePage.dialogueBImg" 
              alt="" 
              @click="imagePreview(styleTestData.dialoguePage.dialogueBImg)" 
            />
          </div>
          <span>过渡页对话B</span>
        </div>
      </div>
    </div>
    <div class="btn-box" v-else @click="addTransition">添加对话页</div>
    <template v-if="styleTestData.questionPage.length">
      <div class="com-content" v-for="(item,index) in styleTestData.questionPage" :key="index">
        <div class="title-box">
          <span>题目{{index+1}}</span>
          <div>
            <span class="edit-color" @click="editQuestion(item,index)">编辑</span>
            <span class="edit-color del" v-if="styleTestData.questionPage.length > 1" @click="delQuestion(item,index)">删除</span>
          </div>
        </div>
        <div class="home-box answer">
          <div class="item-box">
            <div class="img">
              <img 
                class="img" 
                :src="item.questionBackImg" 
                alt="" 
                @click="imagePreview(item.questionBackImg)" 
              />
            </div>
            <span>背景图</span>
          </div>
          <div class="item-box">
            <div class="img">
              <img 
                class="img" 
                :src="item.questionImg" 
                alt="" 
                @click="imagePreview(item.questionImg)" 
              />
            </div>
            <span>题目</span>
          </div>
        </div>
      </div>
    </template>
    <div class="btn-box" @click="addAnswer">添加题目页</div>
    <template v-if="styleTestData.resultPage.length">
      <div class="com-content" v-for="(item,index) in styleTestData.resultPage" :key="index +1 * 100">
        <div class="title-box">
          <span>结果{{index+1}}</span>
          <div>
            <span class="edit-color" @click="editResultPage(item,index)">编辑</span>
            <span class="edit-color del" v-if="styleTestData.resultPage.length > 1" @click="delResultPage(item,index)">删除</span>
          </div>
        </div>
        <div class="home-box answer">
          <div class="item-box">
            <div class="img">
              <img 
                class="img" 
                :src="item.resultBackImg" 
                alt="" 
                @click="imagePreview(item.resultBackImg)" 
              />
            </div>
            <span>背景图</span>
          </div>
          <div class="item-box">
            <div class="img">
              <img 
                class="img" 
                :src="item.contentImg" 
                alt="" 
                @click="imagePreview(item.contentImg)" 
              />
            </div>
            <span>内容图</span>
          </div>
        </div>
        <div class="box">
          <span>触发题目</span>
          <div class="text">{{item.question}}</div>
        </div>
        <div class="box">
          <span>触发答案</span>
          <div class="text">{{item.answer}}</div>
        </div>
      </div>
    </template>
    <div class="btn-box" v-if="styleTestData.questionPage.length" @click="addResult">添加结果页</div>
    <style-test-loading 
      :isAddLoadingPop.sync="isAddLoadingPop" 
      :loadingPage="loadingPage"
      @loadingPageSaveSuccess="loadingPageSaveSuccess"
    />
    <style-test-home 
      :isAddHomePop.sync="isAddHomePop" 
      :homePage="homePage"
      @homePageSaveSuccess="homePageSaveSuccess"
    />
    <style-test-transition 
      :isAddTransition.sync="isAddTransition"
      :dialoguePage="dialoguePage"
      @dialoguePageSaveSuccess="dialoguePageSaveSuccess"
    />
    <style-test-answer 
      :isAddAnswer.sync="isAddAnswer"
      :questionPage="questionPage"
      @questionPageSaveSuccess="questionPageSaveSuccess"
    />
    <style-test-result 
      :isResult.sync="isResult" 
      :resultPage="resultPage"
      :questionAll="questionAll"
      @resultPageSaveSuccess="resultPageSaveSuccess"
    />
  </div>
</template>
<script>
import styleTestLoading from './style-test-loading'
import styleTestHome from './style-test-home'
import styleTestTransition from './style-test-transition'
import styleTestAnswer from './style-test-answer'
import styleTestResult from './style-test-result'
import { ImagePreview } from 'vant';
import _ from 'loadsh'
export default {
  components: {
    styleTestLoading,
    styleTestHome,
    styleTestTransition,
    styleTestAnswer,
    styleTestResult
  },
  props: {
    value:  {
      type: Object,
      default() {
        return {}
      }
    },
  },
 
  computed: {
    styleTestData: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change',newVal)
      }
    },
    activityId() {
      return this.styleTestData.activityId
    },
    from() {
      return this.$route.query.from
    },
  },
  data() {
    return {
      isAddLoadingPop: false,
      isAddHomePop: false,
      isAddTransition: false,
      isAddAnswer: false,
      isResult: false,
      isEdit: false,
      isEditResult: false,
      loadingPage: {},
      homePage: {},
      dialoguePage: {},
      questionPage: {},
      currentQuestionIndex: 0,
      resultPage: {},
      questionAll: [],
      currentResultIndex: 0
    }
  },
  methods: {
    // 加载页
    addLoading() {
      this.loadingPage = {
        activityId: this.activityId,
        loadingBackImg: '',
        loadingBackImgList: [],
        loadingText: '',
      }
      this.isAddLoadingPop = true
    },
    loadingPageSaveSuccess(loadingPage) {
      this.styleTestData.loadingPage = loadingPage
    },
    editLoading() {
      this.styleTestData.loadingPage.activityId = this.activityId
      this.loadingPage = _.cloneDeep(this.styleTestData.loadingPage)
      this.isAddLoadingPop = true
    },
    imagePreview(img) {
      ImagePreview([img])
    },
    // 首页
    addHome() {
      this.homePage = {
        activityId: this.activityId,
        homeBackImg:'',
        homeBackImgArr: [],
        homeTitleImg: '',
        homeTitleImgArr: [],
        homeBtnImg: '',
        homeBtnImgArr: [],
        homeVisionImg: '',
        homeVisionImgArr: [],
        dynamicImg1: '',
        dynamicImg1Arr: [],
        dynamicImg2: '',
        dynamicImg2Arr: [],
        dynamicImg3: '',
        dynamicImg3Arr: [],

      }
      this.isAddHomePop = true
    },
    homePageSaveSuccess(homePage) {
      this.styleTestData.homePage = homePage
    },
    editHomePage() {
      this.styleTestData.homePage.activityId = this.activityId
      this.homePage = _.cloneDeep(this.styleTestData.homePage)
      this.isAddHomePop = true
    },
    // 对话页
    addTransition() {
      this.dialoguePage = {
        activityId: this.activityId,
        dialogueBackImg: '',
        dialogueBackImgArr: [],
        dialogueAImg: '',
        dialogueAImgArr: [],
        dialogueBImg: '',
        dialogueBImgArr: [],
      }
      this.isAddTransition = true
    },
    dialoguePageSaveSuccess(dialoguePage) {
      this.styleTestData.dialoguePage = dialoguePage
    },
    editDialogue() {
      this.styleTestData.dialoguePage.activityId = this.activityId
      this.dialoguePage = _.cloneDeep(this.styleTestData.dialoguePage)
      this.isAddTransition = true
    },
    // 添加题目
    addAnswer() {
      this.isEdit = false
      this.questionPage = {
        activityId: this.activityId,
        questionBackImg: '',
        questionBackImgArr: [],
        questionImg: '',
        questionImgArr: [],
        answers: [],
        answersArr: [{img: []}]
      }
      this.isAddAnswer = true
    },
    questionPageSaveSuccess(questionPage) {
      if (this.isEdit) {
      this.styleTestData.questionPage[this.currentQuestionIndex] = questionPage
      }else {
        this.styleTestData.questionPage.push(questionPage)
      }
      
    },
    editQuestion(item,index) {
      item.activityId = this.activityId
      this.questionPage = _.cloneDeep(item)
      this.isAddAnswer = true
      this.isEdit = true
      this.currentQuestionIndex = index
    },
    delQuestion(item,index) {
      this.$dialog.confirm({
        title: '删除确定',
        message:`请问是否删除当前题目<br/>删除后无法恢复`,
      }).then( async _ =>{
        if (this.from == 'manager') {
          await this.$api.typeTest.deleteStylePage({activityId:this.activityId, id:item.id})
        }
        this.styleTestData.questionPage.splice(index, 1)
        this.$toast('删除成功')
      })
    },
    // 结果页
    addResult() {
      this.resultPage = {
        activityId: this.activityId,
        resultBackImg: '',
        resultBackImgArr: [],
        embellishImg: '',
        embellishImgArr: [],
        contentImg: '',
        contentImgArr: [],
        rollings: [],
        rollingsArr: [],
        panoramaBtnImg: '',
        panoramaBtnImgArr: [],
        schemeBtnImg: '',
        schemeBtnImgArr: [],
        question: '',
        answer: '',
        styleType: '',
        styleLink: ''
      }
      this.getQuestionAll()
      this.isResult = true
      this.isEditResult = false
    },
    resultPageSaveSuccess(resultPage) {
      if (this.isEditResult) {
        this.styleTestData.resultPage[this.currentResultIndex] = resultPage
      }else {
        this.styleTestData.resultPage.push(resultPage)
      }
      
    },
    editResultPage(item,index) {
      this.getQuestionAll()
      item.activityId = this.activityId
      this.resultPage = _.cloneDeep(item)
      this.isResult = true
      this.isEditResult = true
      this.currentResultIndex = index
    },
    delResultPage(item,index) {
      this.$dialog.confirm({
        title: '删除确定',
        message:`请问是否删除当前结果<br/>删除后无法恢复`,
      }).then( async _ =>{
        if (this.from == 'manager') {
          await this.$api.typeTest.deleteStylePage({activityId:this.activityId, id:item.id})
        }
        this.styleTestData.resultPage.splice(index, 1)
        this.$toast('删除成功')
      })
    },
    getQuestionAll() {
      this.questionAll = []
      this.styleTestData.questionPage.forEach((item,index) => {
        this.questionAll.push(`题目${index+1}`)
      });
    },
    // 参数验证
    verifyParames() {
      if (!this.styleTestData.loadingPage.loadingBackImg) {
        this.$toast('请添加加载页')
        return false
      }else if (!this.styleTestData.homePage.homeBackImg) {
        this.$toast('请添加首页')
        return false
      }else if (!this.styleTestData.dialoguePage.dialogueBackImg) {
        this.$toast('请添加对话页')
        return false
      }else if (!this.styleTestData.questionPage.length) {
        this.$toast('请添加题目')
        return false
      }else if (!this.styleTestData.resultPage.length) {
        this.$toast('请添加结果页')
        return false
      }else {
        return true
      }
    }
  },
  created() {
    this.defaultPhoneHeight = window.innerHeight
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  margin: 15px 0;
  margin-top: 10px;
  .reserve-title {
    padding: 10px 0 0 15px
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    margin 10px 15px
    padding: 0 10px;
    background-color: #fff
    border-radius: 8px;
    .title-box {
      display: flex;
      justify-content: space-between;
      padding: 14px  0;
      border-bottom: 1px solid #ebedf0;
      .edit-color {
        color $mainTextColor
      }
      .del {
        margin-left: 10px;
      }
    }
    .box {
      display: flex;
      justify-content: space-between;
      padding: 14px  0;
      border-bottom: 1px solid #ebedf0;
      .img {
        width: 100px;
        height: 100px;
        background: #ccc;
      }
      .text {
        width: 230px;
        text-align: right;
      }
    }
    .home-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item-box {
        margin-top: 10px;
        width: 100px;
        .img {
          width: 100px;
          height: 100px;
          background: #ccc;
        }
        span {
          display: block
          text-align: center;
          padding: 10px 0;
        }
      }
    }
    .answer {
      width: 220px;
      .item-box {
        margin-right: 10px;
      }
    }
    
  }
  .btn-box {
    margin 10px 15px
    padding 6px 0
    text-align: center
    color $mainTextColor
    font-size 14px
    font-weight 600
    border 1px solid $mainTextColor
    border-radius 8px
  }
}
</style>